<div class="dialog">
  <app-dialog-header>
    {{
      (isEdit ? "AI_TOKENS.EDIT_QUOTA" : "AI_TOKENS.CREATE_QUOTA") | translate
    }}
  </app-dialog-header>

  <form [formGroup]="form" (ngSubmit)="submit()">
    <div class="dialog-body">
      <mat-form-field appearance="outline" class="row w-100 m-b-15">
        <mat-label>{{ "AI_TOKENS.PERIOD" | translate }}</mat-label>
        <mat-select formControlName="period">
          <mat-option *ngFor="let p of periods" [value]="p">
            {{ periodLabelKey(p) | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="row w-100">
        <mat-label>{{ "AI_TOKENS.LIMIT_USD" | translate }}</mat-label>
        <input
          matInput
          type="number"
          min="0.01"
          step="0.01"
          formControlName="maxCostDollars"
        />
        <mat-error *ngIf="form.controls['maxCostDollars'].hasError('required')">
          {{ "AI_TOKENS.AMOUNT_REQUIRED" | translate }}
        </mat-error>
        <mat-error *ngIf="form.controls['maxCostDollars'].hasError('min')">
          {{ "AI_TOKENS.AMOUNT_MUST_BE_POSITIVE" | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="dialog-footer">
      <button
        type="button"
        (click)="cancel()"
        class="btn gray-bg m-r-15"
        [disabled]="saving"
      >
        {{ "GENERALS.CANCEL" | translate }}
      </button>
      <button
        type="submit"
        class="btn orange-bg"
        [disabled]="form.invalid || saving"
      >
        {{ "GENERALS.SAVE" | translate }}
      </button>
      <div class="clear"></div>
    </div>
  </form>
</div>
